// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Container = require("../common/Components/Container.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let VerifiedAgentCard = require("../common/Components/VerifiedAgentCard.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let SharedRentalProperty = require("./SharedRentalProperty.bs.js");
let SharedForSaleProperty = require("./SharedForSaleProperty.bs.js");
let SharedPropertyMessage = require("./SharedPropertyMessage.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let WithdrawnSharedPropertyV5 = require("./WithdrawnSharedPropertyV5.bs.js");
let UnselectedUnionMemberError = require("../common/ErrorHandling/UnselectedUnionMemberError.bs.js");
let RelaySharedProperty_sharedProperty_graphql = require("../../__generated__/RelaySharedProperty_sharedProperty_graphql.bs.js");

let convertFragment = RelaySharedProperty_sharedProperty_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, RelaySharedProperty_sharedProperty_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(RelaySharedProperty_sharedProperty_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, RelaySharedProperty_sharedProperty_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(RelaySharedProperty_sharedProperty_graphql.node, convertFragment, fRef);
}

let Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function RelaySharedProperty(props) {
  let sharedProperty = RescriptRelay_Fragment.useFragment(RelaySharedProperty_sharedProperty_graphql.node, convertFragment, props.sharedProperty);
  let p = sharedProperty.property;
  let tmp;
  switch (p.__typename) {
    case "ForSalePropertyV5" :
      tmp = p.status.__typename === "WithdrawnProperty" ? JsxRuntime.jsxs(JsxRuntime.Fragment, {
          children: [
            JsxRuntime.jsx(WithdrawnSharedPropertyV5.make, {
              property: p.fragmentRefs,
              sharedProperty: sharedProperty.fragmentRefs
            }),
            JsxRuntime.jsx(Container.make, {
              children: JsxRuntime.jsx(VerifiedAgentCard.FromSharedProperty.make, {
                sharedProperty: sharedProperty.fragmentRefs
              })
            })
          ]
        }) : JsxRuntime.jsxs(JsxRuntime.Fragment, {
          children: [
            JsxRuntime.jsx(SharedPropertyMessage.make, {
              sharedProperty: sharedProperty.fragmentRefs
            }),
            JsxRuntime.jsx(SharedForSaleProperty.make, {
              property: p.fragmentRefs,
              sharedProperty: sharedProperty.fragmentRefs
            }),
            JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(Container.make, {
                className: "py-4",
                children: JsxRuntime.jsx(VerifiedAgentCard.FromSharedProperty.make, {
                  sharedProperty: sharedProperty.fragmentRefs
                })
              }),
              className: "bg-gray-100"
            })
          ]
        });
      break;
    case "RentalPropertyV5" :
      tmp = p.status.__typename === "WithdrawnProperty" ? JsxRuntime.jsxs(JsxRuntime.Fragment, {
          children: [
            JsxRuntime.jsx(WithdrawnSharedPropertyV5.make, {
              property: p.fragmentRefs,
              sharedProperty: sharedProperty.fragmentRefs
            }),
            JsxRuntime.jsx(Container.make, {
              children: JsxRuntime.jsx(VerifiedAgentCard.FromSharedProperty.make, {
                sharedProperty: sharedProperty.fragmentRefs
              })
            })
          ]
        }) : JsxRuntime.jsxs(JsxRuntime.Fragment, {
          children: [
            JsxRuntime.jsx(SharedPropertyMessage.make, {
              sharedProperty: sharedProperty.fragmentRefs
            }),
            JsxRuntime.jsx(SharedRentalProperty.make, {
              property: p.fragmentRefs,
              sharedProperty: sharedProperty.fragmentRefs
            }),
            JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(Container.make, {
                className: "py-4",
                children: JsxRuntime.jsx(VerifiedAgentCard.FromSharedProperty.make, {
                  sharedProperty: sharedProperty.fragmentRefs
                })
              }),
              className: "bg-gray-100"
            })
          ]
        });
      break;
    case "__unselected" :
      tmp = UnselectedUnionMemberError.raise(`Unknown property type ` + p._0);
      break;
  }
  return JsxRuntime.jsx("div", {
    children: tmp,
    className: "pt-8 flex flex-col gap-12"
  });
}

let make = RelaySharedProperty;

exports.Fragment = Fragment;
exports.make = make;
/* Container Not a pure module */
